/*
 * Copyright (c) 2020, Neustar, Inc.
 * UNPUBLISHED PROPRIETARY SOURCE CODE
 *
 */

import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Link } from "@reach/router";
import localConfig from "../common/localConfig";
import actionTypes from "../actionTypes";
import Switch from "../components/reusable/Swtich";
import getCookie from "../common/helpers/getCookie";
import { List } from "immutable";
import {
  identityPlannerAllowedUserPrivileges,
  rolesForTiles,
} from "../common/globalVariables";

// TODO - get rid of these arbitrary numeric ids.
// TODO - align these string ids with the tiles in Home.js
//        so that we there only needs to be one condition there.
const togglesArr = [
  {
    toggleText: "Select All",
    toggleType: "selectAll",
  },
  {
    toggleText: "Login Notification",
    toggleType: "loginNotification",
  },
  {
    toggleText: "Taxonomy API Error Reporting",
    toggleType: "taxonomyApiErrorReporting",
  },
  {
    toggleText: "Insights (Legacy App)",
    toggleType: "showInsights",
  },
  {
    toggleText: "Integrations (Legacy App)",
    toggleType: "showIntegrations",
  },
  {
    toggleText: "Manage (Legacy App)",
    toggleType: "showManage",
  },
  {
    toggleText: "Reports (Legacy App)",
    toggleType: "showReports",
  },
  {
    toggleText: "Show Header Current Instance Dropdown",
    toggleType: "bonusHeaderFunctionality",
  },
  {
    toggleText: "View & Manage Taxonomy Licensing",
    toggleType: "taxonomyLicensing",
  },
  {
    toggleText:"Taxonomy Metadata ",
    toggleType:'taxonomyMetaData'
  },
  {
    toggleText:"Syndication Wizard Platform Content ",
    toggleType:'syndicationWizardPlatformContent'
  }
];

class FeatureToggle extends Component {
  componentDidMount() {
    this.checkToggleStatus;
  }

  checkToggleStatus = (a, allFeatureFlags) => {
    const privs = _.get(this.props.userInfo, "privileges", []);
    const featureFlagValue =
      allFeatureFlags[a.toggleType] === undefined || _.isEmpty(allFeatureFlags);
    // this is till identity option is not edited
    _.forEach(_.keys(rolesForTiles), (key) => {
      if (
        (a.checkForUserRole &&
          a.toggleType === "identityPlannerBeta" &&
          featureFlagValue) ||
          (a.toggleType === 'taxonomyLicensing' &&
          (privs.includes(rolesForTiles[key]) ||
            _.forEach(rolesForTiles[key], (item) => {
              privs.includes(item);
            })) &&
          featureFlagValue) ||
          (a.toggleType === 'taxonomyMetaData' &&
          (privs.includes(rolesForTiles[key]) ||
            _.forEach(rolesForTiles[key], (item) => {
              privs.includes(item);
            })) &&
          featureFlagValue) ||
          (a.toggleType === 'bonusHeaderFunctionality' &&
          (privs.includes(rolesForTiles[key]) ||
            _.forEach(rolesForTiles[key], (item) => {
              privs.includes(item);
            })) &&
          featureFlagValue) ||
          (a.toggleType === key &&
          (privs.includes(rolesForTiles[key]) ||
            _.forEach(rolesForTiles[key], (item) => {
              privs.includes(item);
            })) &&
          featureFlagValue)
      ) {
        allFeatureFlags[a.toggleType] = true;
      }
    });

    return allFeatureFlags[a.toggleType];
  };

  handleToggle = (a, allFeatureFlags) => {
    // this is when identity option is not edited
    const isIdentityPlannerEnabled =
      _.isEmpty(allFeatureFlags) &&
      _.difference(
        identityPlannerAllowedUserPrivileges,
        this.props.userInfo.privileges
      ).length === 0;
    if (
      a.checkForUserRole &&
      a.toggleType === "identityPlannerBeta" &&
      _.isEmpty(allFeatureFlags)
    ) {
      return this.props.setFeatureFlag(a.toggleType, false, allFeatureFlags);
    }
    if (a.toggleType === "selectAll") {
      const selectAllEnabled =
        allFeatureFlags[a.toggleType] === undefined
          ? true
          : !allFeatureFlags[a.toggleType];
      _.map(togglesArr, (elem) => {
        if (elem.toggleType !== "selectAll") {
          allFeatureFlags[elem.toggleType] = !allFeatureFlags[a.toggleType];
        }
      });
      this.props.setFeatureFlag(
        a.toggleType,
        selectAllEnabled,
        allFeatureFlags,
        isIdentityPlannerEnabled
      );
    } else
      this.props.setFeatureFlag(
        a.toggleType,
        !allFeatureFlags[a.toggleType],
        allFeatureFlags,
        isIdentityPlannerEnabled
      );
      
  };
  resetToDefault = (allFeatureFlags) => {
    // Add code to handle Reset to default event.
    const privs = _.get(this.props.userInfo, "privileges", []);
    this.props.deleteFeatureFlag();
    _.map(togglesArr, (val) => {
      const featureFlagValue =
        allFeatureFlags[val.toggleType] === undefined ||
        _.isEmpty(allFeatureFlags);
      _.forEach(_.keys(rolesForTiles), (key) => {
        if (
          (val.toggleType === "identityPlannerBeta" &&
            _.difference(identityPlannerAllowedUserPrivileges, privs).length ===
              0 &&
            featureFlagValue)
             ||
          (val.toggleType === key &&
            (privs.includes(rolesForTiles[key]) ||
              _.forEach(rolesForTiles[key], (item) => {
                privs.includes(item);
              })) &&
            featureFlagValue)
        ) {
          allFeatureFlags[val.toggleType] = true;
        } else {
          allFeatureFlags[val.toggleType] = false;
        }
      });
    });
    return allFeatureFlags;
  };

  deleteSelectedAdvertiser = () => {
    this.props.deleteSelectedAdvertiser("advertiserId");
    this.props.deleteSelectedAdvertiser("advertiserName");
    this.props.deleteSelectedAdvertiser("advertiserGroupId");
  };

  render() {
    // initially we may get features as object but when we update its a string
    const allFeatureFlags =
      typeof this.props.featureFlags === "string"
        ? JSON.parse(this.props.featureFlags)
        : this.props.featureFlags;
    return (
      <div className="fake-page">
        <div className="fake-header">
          <div className="fake-header-top">
            <Link to={`${localConfig.contextPath}/`}>
              <div className="platform-logo">
                <img
                  src={`${localConfig.contextPath}/images/svg/neustar-platformOne-logo.svg`}
                  alt=""
                />
              </div>
            </Link>
          </div>
          {/* <div className="fake-header-nav">
            <div className="fake-tab active">
              <Link to={`${localConfig.contextPath}/`}>
                <div className="fake-tab-label">
                  <span className="idmp-ico home" id="HomeLinkFakeHeaderNav"></span>
                  PlatformOne
                </div>
              </Link>
            </div>
          </div> */}
          <div className="idmp-homepage text-center">
            <div className="feature-toggle-container py-4">
              <h3>Toggle Features</h3>
              <div className="py-2">
                {togglesArr.map((a) => (
                  <Switch
                    isOn={this.checkToggleStatus(a, allFeatureFlags)}
                    handleToggle={() => this.handleToggle(a, allFeatureFlags)}
                    switchText={a.toggleText}
                    id={a.toggleType}
                    key={a.toggleType}
                  />
                ))}
                <div className="flex-container">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => this.resetToDefault(allFeatureFlags)}
                  >
                    Reset to User's P1 Roles
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => this.deleteSelectedAdvertiser()}
                  >
                    Clear Previously Selected Advertiser
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    userInfo: state.getIn(
      `endpoints.provisioning.v1.0/authentications/${_.get(
        getCookie("sessionAttributes"),
        "userId",
        0
      )}.get.response`.split("."),
      new List()
    ),
    featureFlags: state.getIn("browserScope.features".split(".")),
  }),
  (dispatch) => ({
    setFeatureFlag: (
      featureType,
      featureValue,
      prevFeatureFlags,
      isIdentityPlannerEnabled = false
    ) => {
      let newFeatureFlags = {
        ...prevFeatureFlags,
        [`${featureType}`]: featureValue,
      };
      if (isIdentityPlannerEnabled) {
        newFeatureFlags = {
          ...newFeatureFlags,
          identityPlannerBeta: true,
        };
      }
      dispatch({
        type: actionTypes.SET_USER_SELECTION,
        payload: {
          name: "features",
          value: JSON.stringify(newFeatureFlags), // need to stringify the object to save in localstorage
        },
      });
    },
    deleteFeatureFlag: () => {
      dispatch({
        type: actionTypes.DELETE_USER_SELECTION,
        payload: {
          name: "features",
          value: JSON.stringify({}),
        },
      });
    },
    deleteSelectedAdvertiser: (val) => {
      dispatch({
        type: actionTypes.DELETE_USER_SELECTION,
        payload: {
          name: val,
          value: null,
        },
      });
    },
  })
)(FeatureToggle);
